export const countries = [
  {
    code: "AF",
    flag: "https://flagcdn.com/af.svg",
    name: "Afghanistan",
    phoneCode: "+93",
  },
  {
    code: "AL",
    flag: "https://flagcdn.com/al.svg",
    name: "Albania",
    phoneCode: "+355",
  },
  {
    code: "DZ",
    flag: "https://flagcdn.com/dz.svg",
    name: "Algeria",
    phoneCode: "+213",
  },
  {
    code: "AS",
    flag: "https://flagcdn.com/as.svg",
    name: "American Samoa",
    phoneCode: "+1684",
  },
  {
    code: "AD",
    flag: "https://flagcdn.com/ad.svg",
    name: "Andorra",
    phoneCode: "+376",
  },
  {
    code: "AO",
    flag: "https://flagcdn.com/ao.svg",
    name: "Angola",
    phoneCode: "+244",
  },
  {
    code: "AI",
    flag: "https://flagcdn.com/ai.svg",
    name: "Anguilla",
    phoneCode: "+1264",
  },
  {
    code: "AQ",
    flag: "https://flagcdn.com/aq.svg",
    name: "Antarctica",
    phoneCode: "+672",
  },
  {
    code: "AG",
    flag: "https://flagcdn.com/ag.svg",
    name: "Antigua and Barbuda",
    phoneCode: "+1268",
  },
  {
    code: "AR",
    flag: "https://flagcdn.com/ar.svg",
    name: "Argentina",
    phoneCode: "+54",
  },
  {
    code: "AM",
    flag: "https://flagcdn.com/am.svg",
    name: "Armenia",
    phoneCode: "+374",
  },
  {
    code: "AW",
    flag: "https://flagcdn.com/aw.svg",
    name: "Aruba",
    phoneCode: "+297",
  },
  {
    code: "AU",
    flag: "https://flagcdn.com/au.svg",
    name: "Australia",
    phoneCode: "+61",
  },
  {
    code: "AT",
    flag: "https://flagcdn.com/at.svg",
    name: "Austria",
    phoneCode: "+43",
  },
  {
    code: "AZ",
    flag: "https://flagcdn.com/az.svg",
    name: "Azerbaijan",
    phoneCode: "+994",
  },
  {
    code: "BS",
    flag: "https://flagcdn.com/bs.svg",
    name: "Bahamas",
    phoneCode: "+1242",
  },
  {
    code: "BH",
    flag: "https://flagcdn.com/bh.svg",
    name: "Bahrain",
    phoneCode: "+973",
  },
  {
    code: "BD",
    flag: "https://flagcdn.com/bd.svg",
    name: "Bangladesh",
    phoneCode: "+880",
  },
  {
    code: "BB",
    flag: "https://flagcdn.com/bb.svg",
    name: "Barbados",
    phoneCode: "+1246",
  },
  {
    code: "BY",
    flag: "https://flagcdn.com/by.svg",
    name: "Belarus",
    phoneCode: "+375",
  },
  {
    code: "BE",
    flag: "https://flagcdn.com/be.svg",
    name: "Belgium",
    phoneCode: "+32",
  },
  {
    code: "BZ",
    flag: "https://flagcdn.com/bz.svg",
    name: "Belize",
    phoneCode: "+501",
  },
  {
    code: "BJ",
    flag: "https://flagcdn.com/bj.svg",
    name: "Benin",
    phoneCode: "+229",
  },
  {
    code: "BM",
    flag: "https://flagcdn.com/bm.svg",
    name: "Bermuda",
    phoneCode: "+1441",
  },
  {
    code: "BT",
    flag: "https://flagcdn.com/bt.svg",
    name: "Bhutan",
    phoneCode: "+975",
  },
  {
    code: "BO",
    flag: "https://flagcdn.com/bo.svg",
    name: "Bolivia",
    phoneCode: "+591",
  },
  {
    code: "BA",
    flag: "https://flagcdn.com/ba.svg",
    name: "Bosnia and Herzegovina",
    phoneCode: "+387",
  },
  {
    code: "BW",
    flag: "https://flagcdn.com/bw.svg",
    name: "Botswana",
    phoneCode: "+267",
  },
  {
    code: "BR",
    flag: "https://flagcdn.com/br.svg",
    name: "Brazil",
    phoneCode: "+55",
  },
  {
    code: "BN",
    flag: "https://flagcdn.com/bn.svg",
    name: "Brunei",
    phoneCode: "+673",
  },
  {
    code: "BG",
    flag: "https://flagcdn.com/bg.svg",
    name: "Bulgaria",
    phoneCode: "+359",
  },
  {
    code: "BF",
    flag: "https://flagcdn.com/bf.svg",
    name: "Burkina Faso",
    phoneCode: "+226",
  },
  {
    code: "BI",
    flag: "https://flagcdn.com/bi.svg",
    name: "Burundi",
    phoneCode: "+257",
  },
  {
    code: "KH",
    flag: "https://flagcdn.com/kh.svg",
    name: "Cambodia",
    phoneCode: "+855",
  },
  {
    code: "CM",
    flag: "https://flagcdn.com/cm.svg",
    name: "Cameroon",
    phoneCode: "+237",
  },
  {
    code: "CA",
    flag: "https://flagcdn.com/ca.svg",
    name: "Canada",
    phoneCode: "+1",
  },
  {
    code: "CV",
    flag: "https://flagcdn.com/cv.svg",
    name: "Cape Verde",
    phoneCode: "+238",
  },
  {
    code: "KY",
    flag: "https://flagcdn.com/ky.svg",
    name: "Cayman Islands",
    phoneCode: "+1345",
  },
  {
    code: "CF",
    flag: "https://flagcdn.com/cf.svg",
    name: "Central African Republic",
    phoneCode: "+236",
  },
  {
    code: "TD",
    flag: "https://flagcdn.com/td.svg",
    name: "Chad",
    phoneCode: "+235",
  },
  {
    code: "CL",
    flag: "https://flagcdn.com/cl.svg",
    name: "Chile",
    phoneCode: "+56",
  },
  {
    code: "CN",
    flag: "https://flagcdn.com/cn.svg",
    name: "China",
    phoneCode: "+86",
  },
  {
    code: "CO",
    flag: "https://flagcdn.com/co.svg",
    name: "Colombia",
    phoneCode: "+57",
  },
  {
    code: "KM",
    flag: "https://flagcdn.com/km.svg",
    name: "Comoros",
    phoneCode: "+269",
  },
  {
    code: "CD",
    flag: "https://flagcdn.com/cd.svg",
    name: "Congo (DRC)",
    phoneCode: "+243",
  },
  {
    code: "CG",
    flag: "https://flagcdn.com/cg.svg",
    name: "Congo (Republic)",
    phoneCode: "+242",
  },
  {
    code: "CR",
    flag: "https://flagcdn.com/cr.svg",
    name: "Costa Rica",
    phoneCode: "+506",
  },
  {
    code: "CI",
    flag: "https://flagcdn.com/ci.svg",
    name: "Côte d’Ivoire",
    phoneCode: "+225",
  },
  {
    code: "HR",
    flag: "https://flagcdn.com/hr.svg",
    name: "Croatia",
    phoneCode: "+385",
  },
  {
    code: "CU",
    flag: "https://flagcdn.com/cu.svg",
    name: "Cuba",
    phoneCode: "+53",
  },
  {
    code: "CY",
    flag: "https://flagcdn.com/cy.svg",
    name: "Cyprus",
    phoneCode: "+357",
  },
  {
    code: "CZ",
    flag: "https://flagcdn.com/cz.svg",
    name: "Czechia",
    phoneCode: "+420",
  },
  {
    code: "DK",
    flag: "https://flagcdn.com/dk.svg",
    name: "Denmark",
    phoneCode: "+45",
  },
  {
    code: "DJ",
    flag: "https://flagcdn.com/dj.svg",
    name: "Djibouti",
    phoneCode: "+253",
  },
  {
    code: "DM",
    flag: "https://flagcdn.com/dm.svg",
    name: "Dominica",
    phoneCode: "+1767",
  },
  {
    code: "DO",
    flag: "https://flagcdn.com/do.svg",
    name: "Dominican Republic",
    phoneCode: "+1809",
  },
  {
    code: "EC",
    flag: "https://flagcdn.com/ec.svg",
    name: "Ecuador",
    phoneCode: "+593",
  },
  {
    code: "EG",
    flag: "https://flagcdn.com/eg.svg",
    name: "Egypt",
    phoneCode: "+20",
  },
  {
    code: "SV",
    flag: "https://flagcdn.com/sv.svg",
    name: "El Salvador",
    phoneCode: "+503",
  },
  {
    code: "GQ",
    flag: "https://flagcdn.com/gq.svg",
    name: "Equatorial Guinea",
    phoneCode: "+240",
  },
  {
    code: "ER",
    flag: "https://flagcdn.com/er.svg",
    name: "Eritrea",
    phoneCode: "+291",
  },
  {
    code: "EE",
    flag: "https://flagcdn.com/ee.svg",
    name: "Estonia",
    phoneCode: "+372",
  },
  {
    code: "SZ",
    flag: "https://flagcdn.com/sz.svg",
    name: "Eswatini",
    phoneCode: "+268",
  },
  {
    code: "ET",
    flag: "https://flagcdn.com/et.svg",
    name: "Ethiopia",
    phoneCode: "+251",
  },
  {
    code: "FJ",
    flag: "https://flagcdn.com/fj.svg",
    name: "Fiji",
    phoneCode: "+679",
  },
  {
    code: "FI",
    flag: "https://flagcdn.com/fi.svg",
    name: "Finland",
    phoneCode: "+358",
  },
  {
    code: "FR",
    flag: "https://flagcdn.com/fr.svg",
    name: "France",
    phoneCode: "+33",
  },
  {
    code: "GA",
    flag: "https://flagcdn.com/ga.svg",
    name: "Gabon",
    phoneCode: "+241",
  },
  {
    code: "GM",
    flag: "https://flagcdn.com/gm.svg",
    name: "Gambia",
    phoneCode: "+220",
  },
  {
    code: "GE",
    flag: "/georgia-flag.png",
    name: "Georgia",
    phoneCode: "+995",
  },
  {
    code: "DE",
    flag: "https://flagcdn.com/de.svg",
    name: "Germany",
    phoneCode: "+49",
  },
  {
    code: "GH",
    flag: "https://flagcdn.com/gh.svg",
    name: "Ghana",
    phoneCode: "+233",
  },
  {
    code: "GR",
    flag: "https://flagcdn.com/gr.svg",
    name: "Greece",
    phoneCode: "+30",
  },
  {
    code: "GD",
    flag: "https://flagcdn.com/gd.svg",
    name: "Grenada",
    phoneCode: "+1473",
  },
  {
    code: "GU",
    flag: "https://flagcdn.com/gu.svg",
    name: "Guam",
    phoneCode: "+1671",
  },
  {
    code: "GT",
    flag: "https://flagcdn.com/gt.svg",
    name: "Guatemala",
    phoneCode: "+502",
  },
  {
    code: "GN",
    flag: "https://flagcdn.com/gn.svg",
    name: "Guinea",
    phoneCode: "+224",
  },
  {
    code: "GW",
    flag: "https://flagcdn.com/gw.svg",
    name: "Guinea-Bissau",
    phoneCode: "+245",
  },
  {
    code: "GY",
    flag: "https://flagcdn.com/gy.svg",
    name: "Guyana",
    phoneCode: "+592",
  },
  {
    code: "HT",
    flag: "https://flagcdn.com/ht.svg",
    name: "Haiti",
    phoneCode: "+509",
  },
  {
    code: "HN",
    flag: "https://flagcdn.com/hn.svg",
    name: "Honduras",
    phoneCode: "+504",
  },
  {
    code: "HK",
    flag: "https://flagcdn.com/hk.svg",
    name: "Hong Kong",
    phoneCode: "+852",
  },
  {
    code: "HU",
    flag: "https://flagcdn.com/hu.svg",
    name: "Hungary",
    phoneCode: "+36",
  },
  {
    code: "IS",
    flag: "https://flagcdn.com/is.svg",
    name: "Iceland",
    phoneCode: "+354",
  },
  {
    code: "IN",
    flag: "https://flagcdn.com/in.svg",
    name: "India",
    phoneCode: "+91",
  },
  {
    code: "ID",
    flag: "https://flagcdn.com/id.svg",
    name: "Indonesia",
    phoneCode: "+62",
  },
  {
    code: "IR",
    flag: "https://flagcdn.com/ir.svg",
    name: "Iran",
    phoneCode: "+98",
  },
  {
    code: "IQ",
    flag: "https://flagcdn.com/iq.svg",
    name: "Iraq",
    phoneCode: "+964",
  },
  {
    code: "IE",
    flag: "https://flagcdn.com/ie.svg",
    name: "Ireland",
    phoneCode: "+353",
  },
  {
    code: "IL",
    flag: "https://flagcdn.com/il.svg",
    name: "Israel",
    phoneCode: "+972",
  },
  {
    code: "IT",
    flag: "https://flagcdn.com/it.svg",
    name: "Italy",
    phoneCode: "+39",
  },
  {
    code: "JM",
    flag: "https://flagcdn.com/jm.svg",
    name: "Jamaica",
    phoneCode: "+1876",
  },
  {
    code: "JP",
    flag: "https://flagcdn.com/jp.svg",
    name: "Japan",
    phoneCode: "+81",
  },
  {
    code: "JO",
    flag: "https://flagcdn.com/jo.svg",
    name: "Jordan",
    phoneCode: "+962",
  },
  {
    code: "KZ",
    flag: "https://flagcdn.com/kz.svg",
    name: "Kazakhstan",
    phoneCode: "+7",
  },
  {
    code: "KE",
    flag: "https://flagcdn.com/ke.svg",
    name: "Kenya",
    phoneCode: "+254",
  },
  {
    code: "KI",
    flag: "https://flagcdn.com/ki.svg",
    name: "Kiribati",
    phoneCode: "+686",
  },
  {
    code: "KW",
    flag: "https://flagcdn.com/kw.svg",
    name: "Kuwait",
    phoneCode: "+965",
  },
  {
    code: "KG",
    flag: "https://flagcdn.com/kg.svg",
    name: "Kyrgyzstan",
    phoneCode: "+996",
  },
  {
    code: "LA",
    flag: "https://flagcdn.com/la.svg",
    name: "Laos",
    phoneCode: "+856",
  },
  {
    code: "LV",
    flag: "https://flagcdn.com/lv.svg",
    name: "Latvia",
    phoneCode: "+371",
  },
  {
    code: "LB",
    flag: "https://flagcdn.com/lb.svg",
    name: "Lebanon",
    phoneCode: "+961",
  },
  {
    code: "LS",
    flag: "https://flagcdn.com/ls.svg",
    name: "Lesotho",
    phoneCode: "+266",
  },
  {
    code: "LR",
    flag: "https://flagcdn.com/lr.svg",
    name: "Liberia",
    phoneCode: "+231",
  },
  {
    code: "LY",
    flag: "https://flagcdn.com/ly.svg",
    name: "Libya",
    phoneCode: "+218",
  },
  {
    code: "LI",
    flag: "https://flagcdn.com/li.svg",
    name: "Liechtenstein",
    phoneCode: "+423",
  },
  {
    code: "LT",
    flag: "https://flagcdn.com/lt.svg",
    name: "Lithuania",
    phoneCode: "+370",
  },
  {
    code: "LU",
    flag: "https://flagcdn.com/lu.svg",
    name: "Luxembourg",
    phoneCode: "+352",
  },
  {
    code: "MO",
    flag: "https://flagcdn.com/mo.svg",
    name: "Macau",
    phoneCode: "+853",
  },
  {
    code: "MG",
    flag: "https://flagcdn.com/mg.svg",
    name: "Madagascar",
    phoneCode: "+261",
  },
  {
    code: "MW",
    flag: "https://flagcdn.com/mw.svg",
    name: "Malawi",
    phoneCode: "+265",
  },
  {
    code: "MY",
    flag: "https://flagcdn.com/my.svg",
    name: "Malaysia",
    phoneCode: "+60",
  },
  {
    code: "MV",
    flag: "https://flagcdn.com/mv.svg",
    name: "Maldives",
    phoneCode: "+960",
  },
  {
    code: "ML",
    flag: "https://flagcdn.com/ml.svg",
    name: "Mali",
    phoneCode: "+223",
  },
  {
    code: "MT",
    flag: "https://flagcdn.com/mt.svg",
    name: "Malta",
    phoneCode: "+356",
  },
  {
    code: "MH",
    flag: "https://flagcdn.com/mh.svg",
    name: "Marshall Islands",
    phoneCode: "+692",
  },
  {
    code: "MR",
    flag: "https://flagcdn.com/mr.svg",
    name: "Mauritania",
    phoneCode: "+222",
  },
  {
    code: "MU",
    flag: "https://flagcdn.com/mu.svg",
    name: "Mauritius",
    phoneCode: "+230",
  },
  {
    code: "MX",
    flag: "https://flagcdn.com/mx.svg",
    name: "Mexico",
    phoneCode: "+52",
  },
  {
    code: "FM",
    flag: "https://flagcdn.com/fm.svg",
    name: "Micronesia",
    phoneCode: "+691",
  },
  {
    code: "MD",
    flag: "https://flagcdn.com/md.svg",
    name: "Moldova",
    phoneCode: "+373",
  },
  {
    code: "MC",
    flag: "https://flagcdn.com/mc.svg",
    name: "Monaco",
    phoneCode: "+377",
  },
  {
    code: "MN",
    flag: "https://flagcdn.com/mn.svg",
    name: "Mongolia",
    phoneCode: "+976",
  },
  {
    code: "ME",
    flag: "https://flagcdn.com/me.svg",
    name: "Montenegro",
    phoneCode: "+382",
  },
  {
    code: "MA",
    flag: "https://flagcdn.com/ma.svg",
    name: "Morocco",
    phoneCode: "+212",
  },
  {
    code: "MZ",
    flag: "https://flagcdn.com/mz.svg",
    name: "Mozambique",
    phoneCode: "+258",
  },
  {
    code: "MM",
    flag: "https://flagcdn.com/mm.svg",
    name: "Myanmar",
    phoneCode: "+95",
  },
  {
    code: "NA",
    flag: "https://flagcdn.com/na.svg",
    name: "Namibia",
    phoneCode: "+264",
  },
  {
    code: "NR",
    flag: "https://flagcdn.com/nr.svg",
    name: "Nauru",
    phoneCode: "+674",
  },
  {
    code: "NP",
    flag: "https://flagcdn.com/np.svg",
    name: "Nepal",
    phoneCode: "+977",
  },
  {
    code: "NL",
    flag: "https://flagcdn.com/nl.svg",
    name: "Netherlands",
    phoneCode: "+31",
  },
  {
    code: "NZ",
    flag: "https://flagcdn.com/nz.svg",
    name: "New Zealand",
    phoneCode: "+64",
  },
  {
    code: "NI",
    flag: "https://flagcdn.com/ni.svg",
    name: "Nicaragua",
    phoneCode: "+505",
  },
  {
    code: "NE",
    flag: "https://flagcdn.com/ne.svg",
    name: "Niger",
    phoneCode: "+227",
  },
  {
    code: "NG",
    flag: "https://flagcdn.com/ng.svg",
    name: "Nigeria",
    phoneCode: "+234",
  },
  {
    code: "KP",
    flag: "https://flagcdn.com/kp.svg",
    name: "North Korea",
    phoneCode: "+850",
  },
  {
    code: "MK",
    flag: "https://flagcdn.com/mk.svg",
    name: "North Macedonia",
    phoneCode: "+389",
  },
  {
    code: "NO",
    flag: "https://flagcdn.com/no.svg",
    name: "Norway",
    phoneCode: "+47",
  },
  {
    code: "OM",
    flag: "https://flagcdn.com/om.svg",
    name: "Oman",
    phoneCode: "+968",
  },
  {
    code: "PK",
    flag: "https://flagcdn.com/pk.svg",
    name: "Pakistan",
    phoneCode: "+92",
  },
  {
    code: "PW",
    flag: "https://flagcdn.com/pw.svg",
    name: "Palau",
    phoneCode: "+680",
  },
  {
    code: "PS",
    flag: "https://flagcdn.com/ps.svg",
    name: "Palestine",
    phoneCode: "+970",
  },
  {
    code: "PA",
    flag: "https://flagcdn.com/pa.svg",
    name: "Panama",
    phoneCode: "+507",
  },
  {
    code: "PG",
    flag: "https://flagcdn.com/pg.svg",
    name: "Papua New Guinea",
    phoneCode: "+675",
  },
  {
    code: "PY",
    flag: "https://flagcdn.com/py.svg",
    name: "Paraguay",
    phoneCode: "+595",
  },
  {
    code: "PE",
    flag: "https://flagcdn.com/pe.svg",
    name: "Peru",
    phoneCode: "+51",
  },
  {
    code: "PH",
    flag: "https://flagcdn.com/ph.svg",
    name: "Philippines",
    phoneCode: "+63",
  },
  {
    code: "PL",
    flag: "https://flagcdn.com/pl.svg",
    name: "Poland",
    phoneCode: "+48",
  },
  {
    code: "PT",
    flag: "https://flagcdn.com/pt.svg",
    name: "Portugal",
    phoneCode: "+351",
  },
  {
    code: "QA",
    flag: "https://flagcdn.com/qa.svg",
    name: "Qatar",
    phoneCode: "+974",
  },
  {
    code: "RO",
    flag: "https://flagcdn.com/ro.svg",
    name: "Romania",
    phoneCode: "+40",
  },
  {
    code: "RU",
    flag: "https://flagcdn.com/ru.svg",
    name: "Russia",
    phoneCode: "+7",
  },
  {
    code: "RW",
    flag: "https://flagcdn.com/rw.svg",
    name: "Rwanda",
    phoneCode: "+250",
  },
  {
    code: "KN",
    flag: "https://flagcdn.com/kn.svg",
    name: "Saint Kitts and Nevis",
    phoneCode: "+1869",
  },
  {
    code: "LC",
    flag: "https://flagcdn.com/lc.svg",
    name: "Saint Lucia",
    phoneCode: "+1758",
  },
  {
    code: "VC",
    flag: "https://flagcdn.com/vc.svg",
    name: "Saint Vincent and the Grenadines",
    phoneCode: "+1784",
  },
  {
    code: "WS",
    flag: "https://flagcdn.com/ws.svg",
    name: "Samoa",
    phoneCode: "+685",
  },
  {
    code: "SM",
    flag: "https://flagcdn.com/sm.svg",
    name: "San Marino",
    phoneCode: "+378",
  },
  {
    code: "ST",
    flag: "https://flagcdn.com/st.svg",
    name: "São Tomé and Príncipe",
    phoneCode: "+239",
  },
  {
    code: "SA",
    flag: "https://flagcdn.com/sa.svg",
    name: "Saudi Arabia",
    phoneCode: "+966",
  },
  {
    code: "SN",
    flag: "https://flagcdn.com/sn.svg",
    name: "Senegal",
    phoneCode: "+221",
  },
  {
    code: "RS",
    flag: "https://flagcdn.com/rs.svg",
    name: "Serbia",
    phoneCode: "+381",
  },
  {
    code: "SC",
    flag: "https://flagcdn.com/sc.svg",
    name: "Seychelles",
    phoneCode: "+248",
  },
  {
    code: "SL",
    flag: "https://flagcdn.com/sl.svg",
    name: "Sierra Leone",
    phoneCode: "+232",
  },
  {
    code: "SG",
    flag: "https://flagcdn.com/sg.svg",
    name: "Singapore",
    phoneCode: "+65",
  },
  {
    code: "SK",
    flag: "https://flagcdn.com/sk.svg",
    name: "Slovakia",
    phoneCode: "+421",
  },
  {
    code: "SI",
    flag: "https://flagcdn.com/si.svg",
    name: "Slovenia",
    phoneCode: "+386",
  },
  {
    code: "SB",
    flag: "https://flagcdn.com/sb.svg",
    name: "Solomon Islands",
    phoneCode: "+677",
  },
  {
    code: "SO",
    flag: "https://flagcdn.com/so.svg",
    name: "Somalia",
    phoneCode: "+252",
  },
  {
    code: "ZA",
    flag: "https://flagcdn.com/za.svg",
    name: "South Africa",
    phoneCode: "+27",
  },
  {
    code: "KR",
    flag: "https://flagcdn.com/kr.svg",
    name: "South Korea",
    phoneCode: "+82",
  },
  {
    code: "SS",
    flag: "https://flagcdn.com/ss.svg",
    name: "South Sudan",
    phoneCode: "+211",
  },
  {
    code: "ES",
    flag: "https://flagcdn.com/es.svg",
    name: "Spain",
    phoneCode: "+34",
  },
  {
    code: "LK",
    flag: "https://flagcdn.com/lk.svg",
    name: "Sri Lanka",
    phoneCode: "+94",
  },
  {
    code: "SD",
    flag: "https://flagcdn.com/sd.svg",
    name: "Sudan",
    phoneCode: "+249",
  },
  {
    code: "SR",
    flag: "https://flagcdn.com/sr.svg",
    name: "Suriname",
    phoneCode: "+597",
  },
  {
    code: "SE",
    flag: "https://flagcdn.com/se.svg",
    name: "Sweden",
    phoneCode: "+46",
  },
  {
    code: "CH",
    flag: "https://flagcdn.com/ch.svg",
    name: "Switzerland",
    phoneCode: "+41",
  },
  {
    code: "SY",
    flag: "https://flagcdn.com/sy.svg",
    name: "Syria",
    phoneCode: "+963",
  },
  {
    code: "TW",
    flag: "https://flagcdn.com/tw.svg",
    name: "Taiwan",
    phoneCode: "+886",
  },
  {
    code: "TJ",
    flag: "https://flagcdn.com/tj.svg",
    name: "Tajikistan",
    phoneCode: "+992",
  },
  {
    code: "TZ",
    flag: "https://flagcdn.com/tz.svg",
    name: "Tanzania",
    phoneCode: "+255",
  },
  {
    code: "TH",
    flag: "https://flagcdn.com/th.svg",
    name: "Thailand",
    phoneCode: "+66",
  },
  {
    code: "TL",
    flag: "https://flagcdn.com/tl.svg",
    name: "Timor-Leste",
    phoneCode: "+670",
  },
  {
    code: "TG",
    flag: "https://flagcdn.com/tg.svg",
    name: "Togo",
    phoneCode: "+228",
  },
  {
    code: "TO",
    flag: "https://flagcdn.com/to.svg",
    name: "Tonga",
    phoneCode: "+676",
  },
  {
    code: "TT",
    flag: "https://flagcdn.com/tt.svg",
    name: "Trinidad and Tobago",
    phoneCode: "+1868",
  },
  {
    code: "TN",
    flag: "https://flagcdn.com/tn.svg",
    name: "Tunisia",
    phoneCode: "+216",
  },
  {
    code: "TR",
    flag: "https://flagcdn.com/tr.svg",
    name: "Turkey",
    phoneCode: "+90",
  },
  {
    code: "TM",
    flag: "https://flagcdn.com/tm.svg",
    name: "Turkmenistan",
    phoneCode: "+993",
  },
  {
    code: "TV",
    flag: "https://flagcdn.com/tv.svg",
    name: "Tuvalu",
    phoneCode: "+688",
  },
  {
    code: "UG",
    flag: "https://flagcdn.com/ug.svg",
    name: "Uganda",
    phoneCode: "+256",
  },
  {
    code: "UA",
    flag: "https://flagcdn.com/ua.svg",
    name: "Ukraine",
    phoneCode: "+380",
  },
  {
    code: "AE",
    flag: "https://flagcdn.com/ae.svg",
    name: "United Arab Emirates",
    phoneCode: "+971",
  },
  {
    code: "GB",
    flag: "https://flagcdn.com/gb.svg",
    name: "United Kingdom",
    phoneCode: "+44",
  },
  {
    code: "US",
    flag: "/usa-flag.png",
    name: "United States",
    phoneCode: "+1",
  },
  {
    code: "UY",
    flag: "https://flagcdn.com/uy.svg",
    name: "Uruguay",
    phoneCode: "+598",
  },
  {
    code: "UZ",
    flag: "https://flagcdn.com/uz.svg",
    name: "Uzbekistan",
    phoneCode: "+998",
  },
  {
    code: "VU",
    flag: "https://flagcdn.com/vu.svg",
    name: "Vanuatu",
    phoneCode: "+678",
  },
  {
    code: "VE",
    flag: "https://flagcdn.com/ve.svg",
    name: "Venezuela",
    phoneCode: "+58",
  },
  {
    code: "VN",
    flag: "https://flagcdn.com/vn.svg",
    name: "Vietnam",
    phoneCode: "+84",
  },
  {
    code: "YE",
    flag: "https://flagcdn.com/ye.svg",
    name: "Yemen",
    phoneCode: "+967",
  },
  {
    code: "ZM",
    flag: "https://flagcdn.com/zm.svg",
    name: "Zambia",
    phoneCode: "+260",
  },
  {
    code: "ZW",
    flag: "https://flagcdn.com/zw.svg",
    name: "Zimbabwe",
    phoneCode: "+263",
  },
];
